import { render, staticRenderFns } from "./memberDetail.vue?vue&type=template&id=4d974ef2&"
import script from "./memberDetail.vue?vue&type=script&lang=js&"
export * from "./memberDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports